<template>
  <div
    class="frisbuy-iu__stars-wrap"
    @mousemove="handleHover"
    @mouseleave="resetHover"
  >
    <Vue3StarRating
      :modelValue="displayRating"
      class="frisbuy-iu__stars"
      :numberOfStars="5"
      :starSize="42"
      :starColor="'#23252a'"
      :inactiveColor="'#e6e7ea'"
      :disableClick="false"
      :customSvg="StarRatingIcon"
      @update:modelValue="setRating"
    />
  </div>
</template>

<script setup lang="ts">
import Vue3StarRating from "vue3-star-ratings";
import StarRatingIcon from "./StarRatingIcon.vue";
import { computed, ref, watch } from "vue";

/* NOTE:
  This component uses only for correct working `StarRounded` component as prop.
  Options-API in ImageUpload.vue cannot set component as prop into another component
*/

const props = withDefaults(
  defineProps<{
    modelValue?: number;
  }>(),
  {
    modelValue: () => {
      return 0;
    },
  }
);

const emit = defineEmits<{
  "update:modelValue": [option: number];
}>();

const rating = ref<number>(props.modelValue);
const hoverRating = ref<number | null>(null);
const displayRating = computed(() => {
  if (hoverRating.value !== null) return hoverRating.value;
  return rating.value;
});

function setRating(option: number) {
  const value = Math.ceil(option);
  emit("update:modelValue", value);

  rating.value = value;
}

function handleHover(event: MouseEvent) {
  const element = event.currentTarget as HTMLDivElement;
  if (!element) return;

  const rect = element.getBoundingClientRect();
  const relativeX = event.clientX - rect.left;
  const fraction = relativeX / rect.width;
  const rawValue = fraction * 5;
  const clamped = Math.max(1, Math.min(5, Math.ceil(rawValue)));
  hoverRating.value = clamped;
}

function resetHover() {
  hoverRating.value = null;
}

watch(
  () => props.modelValue,
  (value) => {
    rating.value = Math.ceil(value);
  }
);
</script>

<style lang="scss">
.frisbuy-iu__stars-wrap {
  width: fit-content;
}

.frisbuy-iu__stars {
  width: fit-content;
  line-height: unset !important;
}

.vue3-star-ratings__inner {
  line-height: 12px !important;
}

.frisbuy-iu__stars .vue3-star-ratings__icon {
  padding: 7px;
  box-sizing: content-box;
}

.frisbuy-iu__stars svg {
  display: block;
  width: 42px;
  height: 42px;
}
</style>
